<script setup>
onErrorCaptured((error, instance, info) => {
  console.error("error", error, "instance", instance, "info", info);
});

const site = useState("site", () => null);
const user = useState("user", () => null);

try {
  const [siteRes, userRes] = await Promise.all([
    useFetch2("/api/site"),
    useFetch2("/api/auth/session", { shouldRedirect: false }),
  ]);
  site.value = siteRes.data.value.site;
  user.value = userRes.data.value.user;
} catch (e) {
  console.error(e);
  site.value = null;
  user.value = null;
}
</script>

<template lang="pug">
AppBase(v-if="site", :site-title="site.title")
</template>
